module.exports = __webpack_public_path__ + "static/media/logoSafe.fb337701.svg";